import eventManager from 'eventmanager'
import * as logger from './logger'

/**
 * The module that abstracts Event Manager's debug mode.
 * @module abt-core/app
 */
var debugMode = {}

/**
 * Detects if Event Manager's debug mode exists.
 * @returns {boolean} TRUE if it exists, otherwise false
 */
debugMode.exists = function exists () {
  return !!eventManager.debugMode
}

/** Initializes Event Manager's debug mode if verbose logging is enabled. */
debugMode.init = function init () {
  if (!logger.isVerbose() || !debugMode.exists()) return
  eventManager.debugMode(true, true)
}

export default debugMode



/*****************
 ** WEBPACK FOOTER
 ** ./src/abt-utils/debug-mode.js
 ** module id = 14
 ** module chunks = 2 3
 **/